module.exports = __webpack_public_path__ + "6bd26985e2fb2cff3190881df2d3ee15.png";